import { FormattedMessage } from 'react-intl';

import * as S from '../styled';

const FSLoader = () => (
  <>
    <S.FullScreenLoaderBG />
    <S.FullScreenLoader>
      <FormattedMessage id="loading" />
      <div style={{ marginLeft: '1rem' }} className="loader-spinner2" />
    </S.FullScreenLoader>
  </>
);

export default FSLoader;
